import React, { useState } from "react";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { ToastContainer } from "react-toastify";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import SiteDetails from "./siteDetails.jsx";
import Notification from "./Notification.jsx";
import HrmsAccess from "./hrmsAccess.jsx";

const SiteSettings = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [menuClick, setMenuClick] = useState(false);

  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        <ToastContainer
          enableMultiContainer
          containerId={"F"}
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header
            Header="Site Settings"
            toggleMenu={toggleMenu}
            menuClick={menuClick}
          />
          <div className="main-container">
            <div className="xilliRight">
              <div className="xilliWrap">
                <div className="card main-card">
                  <div className="card-body">
                  <Tabs
                  selectedIndex={tabIndex}
                  onSelect={(index) => {
                    setTabIndex(index);
                  }}
                >
                  <TabList>
                    <Tab>Site Details</Tab>
                    <Tab>Notification</Tab>
                    <Tab>HRMS Access</Tab>
                  </TabList>

                  <TabPanel>
                    <SiteDetails 
                    setTabIndex={setTabIndex}
                    />
                  </TabPanel>

                  <TabPanel>
                    <Notification 
                    setTabIndex={setTabIndex}/>
                  </TabPanel>

                  <TabPanel>
                    <HrmsAccess/>
                  </TabPanel>
                </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SiteSettings;
